import { Link, Stack, Text } from "basis";

function SetPinSuccess({ state }) {
  const { accountInfo } = state;
  const { cardName, cardImageFilename } = accountInfo;

  return (
    <Stack gap="8">
      <img
        width="272"
        height="224"
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        src={require(`../../images/cards/${cardImageFilename}`).default}
        alt={cardName}
        aria-hidden="true"
      />
      <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
        Your card PIN is now ready to be used
      </Text>
      <Text>
        You can now use this card PIN to make purchases where a PIN is required.
      </Text>
      <Link appearance="primary-button" width="192" href="/" newTab={false}>
        Go to overview
      </Link>
    </Stack>
  );
}

export { SetPinSuccess };
